'use client';

import type { VariantsEntity } from '@eliadmin/core/src/api/products/types/product-types';
import {
  sortVariantsByAvailability,
  useVariantsStore,
} from '@eliadmin/core/src/stores/variant-store';

/**
 * The variant the buy box shows: the one in the core variant store (`?vid=`, chips), before the store
 * syncs on mount the variant `VariantsParamsSync` will pick (first available), so the server render
 * matches the hydrated page. Undefined for a product without variants.
 */
export function useActiveVariant(): VariantsEntity | undefined {
  const selected = useVariantsStore(state => state.selectedVariant);
  const variants = useVariantsStore(state => state.product.variants);
  if (selected) return selected;
  return variants?.length ? sortVariantsByAvailability(variants)[0] : undefined;
}

/**
 * Stock state of the product or its variant, with the core rules (`ProductStock`): in stock while
 * pieces are left, otherwise the availability of a sellable item („na objednávku“) or the
 * unavailability („Vypredané“) from the administration.
 */
export function stockState(item: {
  quantity: number;
  availability?: { name?: string | null; sellable?: boolean | null } | null;
  unavailability?: { name?: string | null; sellable?: boolean | null } | null;
}) {
  if (item.quantity > 0) return { inStock: true, sellable: true, count: item.quantity, label: '' };
  const sellable = !!(item.availability?.sellable || item.unavailability?.sellable);
  const label = (item.availability?.sellable ? item.availability : item.unavailability)?.name ?? '';
  return { inStock: false, sellable, count: 0, label };
}
